module.exports = __webpack_public_path__ + "img/Users.cd0a11a5.svg";